import { useFormContext } from '@calendly/form'
import { I18n } from '@calendly/i18n'
import { BodyText } from '@calendly/ui/components/typography'

import { VerticalSortableContext } from 'components/core/sortable'

import { AddButton } from '../../../components'
import { PanelContentContainer, PanelContentHeader, PanelContentTitle } from '../styles'
import { generateBlankQuestion, reorderQuestions } from './helpers'
import { InviteeQuestion } from './invitee_question'

export const InviteeQuestionsSection = () => {
  const { values: { inviteeQuestions }, setFieldValue } = useFormContext()
  const undeletedQuestions = inviteeQuestions.filter(({ _destroy }) => !_destroy)

  const setItems = (items) => {
    setFieldValue('inviteeQuestions', reorderQuestions(inviteeQuestions, items))
  }

  const onAdd = (newQuestion) => {
    setFieldValue('inviteeQuestions', [...inviteeQuestions, newQuestion])
  }

  const handleAdd = () => {
    onAdd(generateBlankQuestion(undeletedQuestions.length))
  }

  return (
    <PanelContentContainer section>
      <PanelContentHeader>
        <PanelContentTitle>
          {I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.title')}
        </PanelContentTitle>
      </PanelContentHeader>
      <VerticalSortableContext items={undeletedQuestions} setItems={setItems}>
        {inviteeQuestions.map((question, index) => (
          <InviteeQuestion index={index} key={question.id} question={question} />
        ))}
      </VerticalSortableContext>
      {undeletedQuestions.length < 10 && (
        <AddButton onClick={handleAdd}>
          {I18n.t('publisher.event_type_editor.sections.booking_page_options.invitee_questions.add_new_question')}
        </AddButton>
      )}
      {undeletedQuestions.length >= 10 && (
        <BodyText color="muted">
          {I18n.t('publisher.event_types.invitee_questions.reached_question_limit')}
        </BodyText>
      )}
    </PanelContentContainer>
  )
}
